import { StateCreator } from 'zustand';

import {
  handleClose,
  handleCloseIfShowingDraft,
  handleOpen,
  handleRegisterCloseHandler,
  handleRegisterDiscardHandler,
  handleResetState,
  handleSetIsAboveModal,
  handleSetNewMessageExpanded,
  handleUnregisterCloseHandler,
  handleUnregisterDiscardHandler,
  handleUpdateDraftId,
  handleUpdateMessageId,
  INITIAL_STATE,
} from './handlers';
import { MessageDialogStore } from './types';

export const createMessageDialogSlice: StateCreator<MessageDialogStore> = (
  set,
  get,
) => {
  return {
    ...INITIAL_STATE,
    open: (params) => handleOpen(set, get, params),
    close: () => handleClose(set, get),
    closeIfShowingDraft: (draftIds) =>
      handleCloseIfShowingDraft(set, get, draftIds),
    updateMessageId: (messageId) => handleUpdateMessageId(set, messageId),
    updateDraftId: (draftId) => handleUpdateDraftId(set, draftId),
    registerCloseHandler: (handler) => handleRegisterCloseHandler(set, handler),
    unregisterCloseHandler: (handler) =>
      handleUnregisterCloseHandler(set, get, handler),
    registerDiscardHandler: (handler) =>
      handleRegisterDiscardHandler(set, handler),
    unregisterDiscardHandler: (handler) =>
      handleUnregisterDiscardHandler(set, get, handler),
    resetState: () => handleResetState(set, get),
    setIsAboveModal: (value) => handleSetIsAboveModal(set, value),
    setNewMessageExpanded: (value) => handleSetNewMessageExpanded(set, value),
  };
};
